export default __webpack_public_path__ + "static/media/08.c389fc31.jpg";